import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('access_token');
  
  // Si le token n'existe pas, on redirige vers la page de login
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  // Si on est connecté, on affiche le composant enfant (la page admin)
  return children;
};

export default ProtectedRoute;
